(function () {
  if (window.spyVatPriceObserverInitialized) return;
  window.spyVatPriceObserverInitialized = true;

  function parseGermanPrice(text) {
    var normalized = text.replace(/[^\d,.-]/g, '');
    var commaIndex = normalized.lastIndexOf(',');
    var dotIndex = normalized.lastIndexOf('.');

    if (commaIndex > dotIndex) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (dotIndex > commaIndex && commaIndex !== -1) {
      normalized = normalized.replace(/,/g, '');
    } else if (commaIndex !== -1) {
      normalized = normalized.replace(',', '.');
    }

    return Number.parseFloat(normalized);
  }

  function isVisible(element) {
    if (!element || element.getClientRects().length === 0) return false;

    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function syncGrossProductPrices() {
    var priceRoots = document.querySelectorAll(
      '.productView-details .productView-price, .halo-quick-view-popup .productView-price'
    );

    priceRoots.forEach(function (priceRoot) {
      var startingPrice = priceRoot.querySelector('[data-easify-starting-price]');
      var livePrices = Array.from(priceRoot.querySelectorAll(
        '[data-easify-live-price], .price-item--sale:not(.price-item--compare), .price-item--regular'
      ));
      var livePrice = livePrices.find(function (price) {
        var amount = parseGermanPrice(price.textContent);
        return price.classList.contains('tpo_product_price') &&
          Number.isFinite(amount) &&
          amount > 0;
      }) || livePrices.find(function (price) {
        var amount = parseGermanPrice(price.textContent);
        return Number.isFinite(amount) && amount > 0;
      });
      var liveAmount = livePrice ? parseGermanPrice(livePrice.textContent) : 0;
      var netPrice = null;

      if (startingPrice && livePrice) {
        if (Number.isFinite(liveAmount) && liveAmount > 0) {
          startingPrice.hidden = true;
          livePrice.style.removeProperty('display');
          livePrice.style.removeProperty('visibility');
          livePrice.hidden = false;
          netPrice = livePrice;
        } else {
          startingPrice.hidden = false;
          livePrice.hidden = true;
          netPrice = startingPrice;
        }
      } else {
        netPrice = Array.from(
          priceRoot.querySelectorAll(
            '.price-item--sale:not(.price-item--compare), .price-item--regular'
          )
        ).find(isVisible);
      }

      if (!netPrice) return;

      var netAmount = parseGermanPrice(netPrice.textContent);
      if (!Number.isFinite(netAmount)) return;

      var vatBlock = priceRoot.querySelector(
        '.productView-vat-prices, .price-tax-display'
      );
      if (!vatBlock) {
        vatBlock = document.createElement('div');
        vatBlock.className = 'productView-vat-prices';
        vatBlock.innerHTML =
          '<span class="productView-vat-prices__net">Nettopreis, zzgl. 19% MwSt.</span>' +
          '<strong class="productView-vat-prices__gross"></strong>';
        priceRoot.appendChild(vatBlock);
      }

      var grossPrice = vatBlock.querySelector(
        '.productView-vat-prices__gross, .price-tax-display__gross'
      );
      var formattedGross = new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        { style: 'currency', currency: 'EUR' }
      ).format(netAmount * 1.19) + ' Brutto';

      if (grossPrice && grossPrice.textContent !== formattedGross) {
        grossPrice.textContent = formattedGross;
      }
    });
  }

  var syncFrame;
  function scheduleGrossPriceSync() {
    window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(syncGrossProductPrices);
    window.setTimeout(syncGrossProductPrices, 100);
    window.setTimeout(syncGrossProductPrices, 400);
    window.setTimeout(syncGrossProductPrices, 1000);
  }

  function initializeVatPriceSync() {
    new MutationObserver(scheduleGrossPriceSync).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', scheduleGrossPriceSync, true);
    document.addEventListener('input', scheduleGrossPriceSync, true);
    document.addEventListener('click', scheduleGrossPriceSync, true);
    syncGrossProductPrices();
    window.setTimeout(syncGrossProductPrices, 500);
    window.setTimeout(syncGrossProductPrices, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVatPriceSync);
  } else {
    initializeVatPriceSync();
  }
})();
